import React from "react";
import { string } from "prop-types";
import { Icon } from "../../index";
import "./NotificationBar.scss";

export const NotificationWarningBar = ({ text }) => (
  <div className="vg-notification-bar vg-notification-bar-warning">
    <div className="vg-notification-icon vg-notification-icon-warning">
      <Icon iconKey="warning" />
    </div>
    <p className="vg-notification-text vg-notification-text-warning">{text}</p>
  </div>
);

export const NotificationErrorBar = ({ text }) => (
  <div className="vg-notification-bar vg-notification-bar-error">
    <div className="vg-notification-icon vg-notification-icon-error">
      <Icon iconKey="warning" />
    </div>
    <p className="vg-notification-text vg-notification-text-error">{text}</p>
  </div>
);

NotificationWarningBar.propTypes = {
  text: string.isRequired,
};
NotificationErrorBar.propTypes = {
  text: string.isRequired,
};
